G.addTextStyles = () => {
  // font styles
  G.Text.addStyle('font-dark-blue-white-shadow', {
    font: G.Text.defaultFont,
    fill: '#006687',
    shadow: [2, 3, 'rgba(255,255,255,0.7)', 0],
  });

  G.Text.addStyle('font-dark-purple-white-shadow', {
    font: G.Text.defaultFont,
    fill: '#500082',
    shadow: [2, 3, 'rgba(255,255,255,0.7)', 0],
  });

  G.Text.addStyle('font-white', {
    font: G.Text.defaultFont,
    fill: 'white',
    fontSize: '30px',
    shadow: [2, 3, 'rgba(0,0,0,0.3)', 0],
  });
  G.Text.addStyle('spdm-complete-all-panel-1', {
    font: G.Text.defaultFont,
    fill: 'white',
    fontSize: '30px',
    shadow: [2, 3, 'rgba(0,0,0,0.3)', 0],
  });

  G.Text.addStyle('tutorial-msg-text-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });

  G.Text.addStyle('font-wood', {
    font: G.Text.defaultFont,
    fill: '#A6590C',
    fontSize: '30px',
    shadow: [2, 3, 'rgba(255,255,255,0.7)', 0],
  });

  G.Text.addStyle('font-white-blue-out', {
    font: G.Text.defaultFont,
    fill: 'white',
    fontSize: '30px',
    stroke: '#008aca',
    strokeThickness: 5,
  });

  G.Text.addStyle('font-pink-white-out', {
    font: G.Text.defaultFont,
    fill: '#F923A2',
    fontSize: '30px',
    stroke: 'white',
    strokeThickness: 5,
  });

  G.Text.addStyle('font-blue', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('out-of-moves-info-panel-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-win-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-win-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-win-3', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-tournament-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-tournament-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-tournament-3', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-tournament-4', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-tournament-5', {
    font: G.Text.defaultFont,
    fill: '#FFFFFF',
    fontSize: '30px',
  });
  G.Text.addStyle('window-mystery-gift-level-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-level-failed-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-level-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-level-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-level-3', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-give-up-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-fillRate-fallback-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-daily-reward-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('window-daily-reward-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('spdm-mission-panel-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('waffle-Layers-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('waffle-jelly-layers-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('waffle-break-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rope-multi-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rope-multi-tutorial-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rope-break-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rope-break-tutorial-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rock-layers-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('rock-break-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('ice-breaker-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('goal-drop-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('goal-drop-tutorial-2', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('cell-wall-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('burnt-candy-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('bassic-waffle-tutorial-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });
  G.Text.addStyle('daily-reward-gift-1', {
    font: G.Text.defaultFont,
    fill: '#008aca',
    fontSize: '30px',
  });

  G.Text.addStyle('font-orange', {
    font: G.Text.defaultFont,
    fill: '#ff7200',
    fontSize: '30px',
  });

  G.Text.addStyle('font-darkBlue', {
    font: G.Text.defaultFont,
    fill: '#006A8F',
    fontSize: '30px',
  });


  G.Text.addStyle('font-darkBlueRubik', {
    font: G.Text.defaultFont,
    fill: '#006A8F',
    fontSize: '30px',
  });

  G.Text.addStyle('font-num-blue', {
    font: G.Text.defaultFont,
    fill: 'white',
    fontSize: '30px',
    stroke: '#3d95ea',
    strokeThickness: 3,
  });

  G.Text.addStyle('font-num-orange', {
    font: G.Text.defaultFont,
    fill: 'white',
    fontSize: '30px',
    stroke: '#ff7200',
    strokeThickness: 3,
  });

  G.Text.addStyle('font-num-realMoneyWheel', {
    font: G.Text.defaultFont,
    fill: '#D80000',
    fontSize: '30px',
    stroke: '#ffffff',
    strokeThickness: 3,
  });

  G.Text.addStyle('font-score-0', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#eea1c2',
  });

  G.Text.addStyle('font-score-1', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#c52216',
  });

  G.Text.addStyle('font-score-2', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#1eb3e5',
  });

  G.Text.addStyle('font-score-3', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#eac867',
  });

  G.Text.addStyle('font-score-4', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#e34bbc',
  });

  G.Text.addStyle('font-score-5', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#7adc2c',
  });

  G.Text.addStyle('font-score-6', {
    font: G.Text.defaultFont,
    fontSize: '50px',
    stroke: 'white',
    strokeThickness: 8,
    fill: '#e79909',
  });

  G.Text.addStyle('rubikWB', {
    font: G.Text.defaultFont,
    fontSize: '40px',
    stroke: '#49abe8',
    strokeThickness: 6,
    fill: 'white',
  });

  G.Text.addStyle('rubikPW', {
    font: G.Text.defaultFont,
    fontSize: '40px',
    stroke: 'white',
    strokeThickness: 6,
    fill: '#EC048D',
  });

  G.Text.addStyle('font-grey', {
    font: G.Text.defaultFont,
    fontSize: 40,
    fill: '#686F70',
  });

  G.Text.addStyle('editor', {
    font: 'Verdana',
    fontWeight: 'bold',
    fontSize: 40,
    fill: 'white',
    stroke: 'black',
    strokeThickness: 5,
  });

  G.Text.addStyle('editor-aquamarine', {
    font: 'Verdana',
    fontWeight: 'bold',
    fontSize: 40,
    fill: '#a8dbc6',
    stroke: 'black',
    strokeThickness: 5,
  });

  G.Text.addStyle('msg-white', {
    font: G.Text.defaultFont,
    fontSize: '25px',
    fill: 'white',
  });

  G.Text.addStyle('msg-black', {
    font: G.Text.defaultFont,
    fontSize: '64px',
    fill: 'black',
  });

  G.Text.addStyle('msg-yellow', {
    font: G.Text.defaultFont,
    fontSize: '40px',
    fill: '#ffe715',
  });

  G.Text.addStyle('msg-yellow-2', {
    fill: '#fdff36',
    font: G.Text.defaultFont,
    fontSize: '42px',
    align: 'center',
  });

  G.Text.addStyle('msg-fuschia', {
    font: G.Text.defaultFont,
    fontSize: '35px',
    fill: '#de2289',
    stroke: 'white',
    strokeThickness: 8,
  });

  G.Text.addStyle('msg-purpleFontStyle', {
    fill: '#de03ff',
    font: G.Text.defaultFont,
    fontSize: '42px',
    align: 'center',
    stroke: '#ffffff',
    strokeThickness: 10,
  });

  G.Text.addStyle('msg-blueFontStyle', {
    fill: '#0788b9',
    font: G.Text.defaultFont,
    fontSize: '42px',
    align: 'center',
    stroke: '#ffffff',
    strokeThickness: 10,
  });

  G.Text.addStyle('msg-orangeFontStyle', {
    fill: '#fb8013',
    font: G.Text.defaultFont,
    fontSize: '42px',
    align: 'center',
    stroke: '#ffffff',
    strokeThickness: 10,
  });

  G.Text.addStyle('msg-friendChest', {
    font: G.Text.defaultFont,
    fill: 'yellow',
    stroke: '#e08900',
    strokeThickness: 10,
  });

  G.Text.addStyle('msg-friendChestJoined', {
    font: G.Text.defaultFont,
    fontSize: '120px',
    fill: '#ffdeae',
    stroke: '#ce3030',
    strokeThickness: 10,
  });

  G.Text.addStyle('msg-help', {
    font: G.Text.defaultFont,
    fontSize: 26,
    fill: '#D500B9',
  });

  G.Text.addStyle('window-white', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '40px',
  });

  G.Text.addStyle('window-brown', {
    font: G.Text.defaultFont,
    fontSize: '22px',
    fill: '#ab6420',
    lineSpacing: 0,
  });

  G.Text.addStyle('window-blue', {
    fill: '#0089D4',
    font: G.Text.defaultFont,
    fontSize: '35px',
    stroke: '#0089D4',
    lineSpacing: -15,
  });

  G.Text.addStyle('window-blue-2', {
    fill: '#008aca',
    font: G.Text.defaultFont,
    fontSize: '35px',
  });

  G.Text.addStyle('window-starReq', {
    font: G.Text.defaultFont,
    fontSize: '40px',
    fill: '#FFA90F',
    stroke: '#A24A00',
    strokeThickness: 3,
  });

  G.Text.addStyle('mysteryGift-top', {
    fill: '#0089D4',
    font: G.Text.defaultFont,
    fontSize: '30px',
    lineSpacing: -10,
  });

  G.Text.addStyle('mysteryGift-topBig', {
    fill: '#0089D4',
    font: G.Text.defaultFont,
    fontSize: '56px',
    lineSpacing: -10,
  });

  G.Text.addStyle('mysteryGift-bottom', {
    fill: '#0089D4',
    font: G.Text.defaultFont,
    fontSize: '24px',
    lineSpacing: -10,
  });

  G.Text.addStyle('mysteryGift-timer-yellow', {
    fill: '#F2A03C',
    font: G.Text.defaultFont,
    fontSize: '35px',
    stroke: '#0089D4',
    lineSpacing: -15,
  });

  G.Text.addStyle('mysteryGift-timer-red', {
    fill: '#F2A03C',
    font: G.Text.defaultFont,
    fontSize: '35px',
    stroke: '#EA3526',
    lineSpacing: -15,
  });

  G.Text.addStyle('ui-dailyChallenge', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '30px',
    stroke: '#c0317d',
    strokeThickness: 5,
  });

  G.Text.addStyle('ui-dailyIcon', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '30px',
    stroke: 'black',
    strokeThickness: 1,
  });

  G.Text.addStyle('ui-tournament', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '23px',
  });

  G.Text.addStyle('ui-tournament-timecode', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '23px',
  });

  G.Text.addStyle('ui-tournament-promo', {
    fill: '#d20c5b',
    font: G.Text.defaultFont,
    lineSpacing: -10,
  });

  G.Text.addStyle('ui-friendChest', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '30px',
    stroke: 'black',
    strokeThickness: 1,
  });

  G.Text.addStyle('world-sidePanelLockedWidget', {
    fill: 'white',
    font: G.Text.defaultFont,
    fontSize: '30px',
    stroke: 'black',
    strokeThickness: 1,
  });

  G.Text.addStyle('gifts-shareTickbox', {
    fill: '#ffffff',
    font: G.Text.defaultFont,
    fontSize: 46,
    lineSpacing: -10,
  });

  G.Text.addStyle('gifts-achievement', {
    fill: '#0788b9',
    font: G.Text.defaultFont,
    fontSize: '54px',
  });

  G.Text.addStyle('modifyAnimation', {
    font: 'Verdana',
    fontSize: 13,
    fontWeight: 'bold',
  });

  G.Text.addStyle('lossAversionTimer', {
    font: G.Text.defaultFont,
    fill: '#982FC3',
    fontSize: '32px',
  });

  G.Text.addStyle('window_popupOffer-multiplierTxt', {
    style: 'font-white',
    fontSize: '46px',
    shadow: [4, 4, 'rgba(0,0,0,0.3)', 5],
  });
  G.Text.addStyle('window_timedPopupOffer-coinbarTxt', {
    style: 'font-white',
    fill: '#ffffff',
    fontSize: '40px',
  });
  G.Text.addStyle('window_oneTimePopupOffer-coinbarTxt', {
    style: 'font-white',
    fill: '#ffffff',
    fontSize: '40px',
  });
  G.Text.addStyle('window_popupOffer-mascotTxt', {
    style: 'font-blue',
    fill: '#1455FF',
    fontSize: 44,
    lineSpacing: -10,
    font: 'Verdana',
    fontWeight: 'bold',
  });
  G.Text.addStyle('shareMessageText', {
    font: G.Text.defaultFont,
    fontSize: '38px',
    fill: 'white',
    stroke: '#3d95ea',
    strokeThickness: 0,
  });
  G.Text.addStyle('realMoneyWheel-jackpot', {
    font: G.Text.defaultFont,
    fill: '#FFE050',
    fontSize: '32px',
    shadow: [0, 5, 'rgba(0,0,0,0.75)', 0],
  });

  G.Text.addStyle('realMoneyWheel-warning', {
    font: G.Text.defaultFont,
    fill: '#D43808',
    fontSize: '40px',
  });

  // NOTE: Game-specific styles now go in js/Elements/G.addTextStyles.js of their respective game.
};
